const STORAGE_PREFIX = 'edutrackr_';

export enum StorageKeys {
  User = `${STORAGE_PREFIX}user`,
  AccessToken = `${STORAGE_PREFIX}auth_token`,
  RefreshToken = `${STORAGE_PREFIX}refresh_token`,
  LogoutEvent = `${STORAGE_PREFIX}logout`,
}
